import React from 'react';
import {
  Box, Typography, Stack, Switch,
} from '@mui/material';
import { LIMUDIM_PROGRAMS } from '../../../engine/providers/learningProvider';
import { toShowKey } from '../../../business/LimudimWidget/limudimUtils';

const navy = '#1e3a5f';
const selectSx = { '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e5e7eb' } };

const SwitchRow = ({ label, hint, checked, onChange }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Box>
      <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 500 }}>{label}</Typography>
      {hint && <Typography sx={{ fontSize: '0.75rem', color: '#9ca3af', mt: 0.25 }}>{hint}</Typography>}
    </Box>
    <Switch
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      size="small"
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': { color: navy },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: navy },
      }}
    />
  </Stack>
);

const SectionBox = ({ title, children }) => (
  <Box sx={{ bgcolor: 'white', border: '1px solid #e5e7eb', borderRadius: 2, p: 2.5, mb: 2 }}>
    <Typography sx={{ fontWeight: 600, color: '#374151', fontSize: '0.875rem', mb: 1.5 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

/** Category → Hebrew label */
const CATEGORY_HE = {
  gemara:  'גמרא',
  mishna:  'משנה',
  halacha: 'הלכה',
  tanakh:  'תנ"ך',
  mussar:  'מוסר',
};

/** Category display order */
const CATEGORY_ORDER = ['gemara', 'mishna', 'halacha', 'tanakh', 'mussar'];

/** Default-on programs */
const DEFAULT_ON = new Set(['dafYomi', 'mishnaYomi', 'rambam1']);

/** Group programs by category */
const grouped = CATEGORY_ORDER.map((cat) => ({
  category: cat,
  label: CATEGORY_HE[cat],
  programs: LIMUDIM_PROGRAMS.filter((p) => p.category === cat),
})).filter((g) => g.programs.length > 0);

/**
 * LimudimSettingsStep
 * שלב הגדרות לימודים יומיים בוויזרד.
 */
const LimudimSettingsStep = ({ formData, onChange }) => {
  return (
    <Box dir="rtl">
      <Typography sx={{ fontWeight: 700, color: navy, fontSize: '1rem', mb: 0.5 }}>
        הגדרות לימודים יומיים
      </Typography>
      <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', mb: 2.5, lineHeight: 1.5 }}>
        בחר אילו סדרי לימוד יוצגו ברכיב. כל סדר ניתן להפעלה/כיבוי בנפרד.
      </Typography>

      {grouped.map((group) => (
        <SectionBox key={group.category} title={group.label}>
          <Stack spacing={1.5}>
            {group.programs.map((prog) => {
              const showKey = toShowKey(prog.key);
              const checked = formData?.[showKey] ?? DEFAULT_ON.has(prog.key);
              return (
                <SwitchRow
                  key={prog.key}
                  label={prog.he}
                  hint={prog.en}
                  checked={checked}
                  onChange={(v) => onChange({ [showKey]: v })}
                />
              );
            })}
          </Stack>
        </SectionBox>
      ))}
    </Box>
  );
};

export default LimudimSettingsStep;
